// Registering the runtime's service worker and its waiting-worker update
// flow (research §3): a new generation installs, then waits; the page shows
// a quiet "Refresh to update"; the tap sends SKIP_WAITING; the page reloads
// once when its controller changes. Never automatic.

/**
 * container is navigator.serviceWorker (or null). onWaiting() fires when a
 * new generation is ready to take over; onReplaced() when another window
 * let it take over this one. Returns {refresh()} for the chip's tap.
 */
export function registerRuntimeSW({ container, onWaiting, onReplaced = () => {}, reload }) {
  let registration = null;
  let asked = false;
  let reloading = false;
  if (!container?.register) return { refresh() { reload(); }, ready: Promise.resolve(null) };
  const hadController = !!container.controller;
  const watch = (worker) => {
    if (!worker) return;
    const check = () => { if (worker.state === 'installed' && container.controller) onWaiting(); };
    worker.addEventListener?.('statechange', check);
    check();
  };
  container.addEventListener?.('controllerchange', () => {
    // The first install has no controller to change from; nothing to reload.
    if (!hadController) return;
    if (asked) {
      if (reloading) return;
      reloading = true;
      reload();
    } else {
      onReplaced();
    }
  });
  // Registration never blocks the app: it runs after the loader's own work.
  const ready = Promise.resolve().then(() => container.register('/sw.js', { scope: '/', updateViaCache: 'none' })).then((reg) => {
    registration = reg;
    if (reg.waiting && container.controller) onWaiting();
    reg.addEventListener?.('updatefound', () => watch(reg.installing));
    return reg;
  }).catch(() => null);
  return {
    ready,
    refresh() {
      const waiting = registration?.waiting;
      if (!waiting) { reload(); return; }
      asked = true;
      waiting.postMessage({ type: 'SKIP_WAITING' });
    },
  };
}
